import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import FirstAccess from "../FirstAccess";

function LoginFromEmail() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [goToNext, setGoToNext] = useState(false);
  const [signInError, setSignInError] = useState("");

  const { hash } = useParams();

  // const setGoToPage = useCallback((userPermission) => {
  //   let goto = ''
  //   if (userPermission === 1 || userPermission === 2) goto = '/painel/meus-casos'
  //   else if (userPermission === 3) goto = `/caso`

  //   localStorage.setItem('goto', goto)
  //   navigate(goto)
  // }, [navigate])

  useEffect(() => {
    const hashDecoded = window.atob(hash);
    // const hashDecoded = window.atob('YXJ0dXIuZ3VlZGVzQHNlbXByb2Nlc3NvLmNvbS5ici9iZy8yK2FFSlNKT3VYaHJBVVpBVG1HdklZOUE5VjcyelVoOGlKZEJBTTRpZ1dMbWZhL2V2cVhOcElnM2VzSEp6Mjc4R2huWW52eGpjSkp0NXlEekJrZz09')
    const email = hashDecoded.split("/")[0];
    const password = hashDecoded.split("/").splice(1).join("/");
    signInInvite(email, password);
  }, []);

  function signInInvite(login, password) {
    axios
      .post("signin-invite", { login, password })
      .then(({ data }) => {
        dispatch({ type: "CHANGE_USER", payload: data });
        axios.defaults.headers.common["token"] = data.token;
        localStorage.setItem("user", JSON.stringify(data));
        // navigate('/primeiro-acesso')
        fetchList();

        setIsLoading(false);
        setGoToNext(true);
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          // setLoginMessage('')
          setSignInError("Credenciais incorretas");
        } else {
          // setLoginMessage('')
          setSignInError("Login incompleto. Tente novamente mais tarde.");
          // setLoginError('Usuário e/ou senha inválidos.<br/> Tente novamente ou clique em "Esqueceu a senha?" para redefini-la.')
        }
        setIsLoading(false);
      });
  }

  function fetchList() {
    function returnStatusText(statusId) {
      switch (statusId) {
        case 1:
          return "SENT";
        case 2:
          return "NEGOTIATION";
        case 3:
          return "WAITING_APPROVAL";
        case 4:
          return "PAID";
        case 5:
          return "ARCHIVED";
        case 7:
          return "WAITING";
        case 9:
          return "CLOSED";
        default:
          return "WAITING_PAYMENT";
      }
    }

    axios.post("/case/list", {}).then(({ data }) => {
      const debt = data[0];
      const payload = {
        id: debt.id,
        openingDate: debt.opening_date,
        company: {
          name: debt.company,
        },
        status: returnStatusText(debt.status_cases_id),
        totalDebt: debt.value,
      };
      dispatch({ type: "CHANGE_DEBT_INFO", payload });
      // setGoToPage(roles_id, data[0].id)
    });
  }

  return (
    <>
      <FirstAccess
        isLoading={isLoading}
        goToNext={goToNext}
        signInError={signInError}
      />
    </>
  );
}

export default LoginFromEmail;
